var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97904 1.37467H9.4832C10.0378 1.37467 10.4915 1.78717 10.4915 2.29134V9.62467C10.4915 10.1288 10.0378 10.5413 9.4832 10.5413H1.41654C0.861953 10.5413 0.408203 10.1288 0.408203 9.62467V2.29134C0.408203 1.78717 0.861953 1.37467 1.41654 1.37467H1.9207V0.458008H2.92904V1.37467H7.9707V0.458008H8.97904V1.37467ZM1.41654 9.62467H9.4832V3.66634H1.41654V9.62467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersIcon);
export default __webpack_public_path__ + "static/media/layers_icon.7863f342adfb8c07357dad6d8f22c3df.svg";
export { ForwardRef as ReactComponent };